module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "bitcoin-1.d48db2ac.svg";